/**
 * returns HTML formatted Footnote or emtpy string, if no footnote text is given
 * @param footnote
 */
export const getFormattedFootnote = (footnote: string): string => {
    if ('' === footnote.trim()) {
        return '';
    } else {
        return `<sup brix-footnote-link-style>${footnote}</sup>`;
    }
};
